import { create } from "zustand";

import axios from "../helper/axios";


const useQSetStore = create((set) => ({
    myApplication: null,
    myEvals: null,
    myResume: null,
    myQuestions: null,
    myJdArray: null,
       
    sendEvalAnswers: async (body) => {
        try {
           var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
           const response = await axios.post(            
                `/qsetEvalQSetAnswers/${qsetUserData.sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhrid}/${qsetUserData.qhcompanyjid}/${body.ev_id}`,
                body.jasonValues
            );           
            console.log(response.data);
            //set({ selectedProfileResume: response?.data });
        } catch (err) {
            console.error(err);
        }
    },

    updateEvalStatus: async (body) => {
        try {
           var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
           const response = await axios.post(            
                `/qsetEvalSetUpdateStatus/${qsetUserData.sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhrid}/${qsetUserData.qhcompanyjid}/${body.ev_id}`,
                body.jasonValues
            );          
            //console.log(response.data)
            //set({ selectedProfileResume: response?.data });
        } catch (err) {
            console.error(err);
        }
    },

    getMyOffer: async (jdid) => {
        try {
            var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
            const response = await axios.get(`/qsetGetCurrentEvals/${qsetUserData.qhoid}/${jdid}/${qsetUserData.qhrid}`);
            console.log("My Offer",response.data);
            console.log(response.data.data);
            set({ myEvals: response?.data.data });

        } catch (err) {
            console.log("My Evals Data Error",err);
            console.error(err);
        }
    },    
    getMyApplication: async (sessionid) => {
        try {
            var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
            const response = await axios.get(`/qsetGetMyApplication/${sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhcompanyjid}/${qsetUserData.qhrid}`);
            console.log("My Application",response.data);
            console.log(response.data.data);
            set({ myApplication: response?.data.data });
            set({ myResume: response?.data.resumeData });

        } catch (err) {
            console.log("My Application Data Error",err);
            console.error(err);
        }
    },

    getMyEval: async (sessionid) => {
        try {
            var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
            const response = await axios.get(`/qsetGetMyEvals/${sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhcompanyjid}/${qsetUserData.qhrid}`);
            console.log("My Evals",response.data);
            console.log(response.data.data);
            set({ myEvals: response?.data.data ,
                  myQuestions: response?.data.qarray,
                  myJdArray:response?.data.jdarray
            });

        } catch (err) {
            console.log("My Evals Data Error",err);
            console.error(err);
        }
    },
                  
}));

export default useQSetStore;
